import nlLocale from "element-ui/lib/locale/lang/nl";
const nl = {
  //Dutch 荷兰
  login: {
    buttoo: {
      add: "新增",
    },
  },
  dialog: {
    buttton: {
      close: "关闭",
    },
    ReportError: {
         //未对应
      next: "Next",
      h1: "Report Errors allows users to communicate with us to solve any data issues and improve data quality.",
      li1: "If you find any data problems or have a question about this data",
      li2: "If you want to contribute company information to improve this data",
      li3: "If you choose not to disclose your own company information that you might consider private",
      li4: "If you have any constructive suggestions for us to improve services",
      h2: "All comments submitted are subject to data verification. Users must complete your own user profile as our representative may contact you for authentication and verification of your company any rights to represent your company.",
    },
  },
  Home: {
       //未对应
    Applications: "Applications",
    SearchCompanies: "Search Companies",
    SearchTrade: "Search Trade",
    SearchRisks: "Search Risks",
    SearchCountries: "Search Countries",
    SearchNews: "Search News",
    SearchLeads: "Search Leads",
    SearchSanctions :"Search Sanctions ",
    RiskScan:"Risk Scan",
    SearchRelationship :"Search Relationship",
    DataServices :"Data Services",


    selectCountry: "Selecteer land",
    inputCompany: "Bedrijfsnaam invoeren",
    keWord: "Trefwoord",
    firstWord: "Tekst (woorden van links)",
    search: "Zoeken",
    homeSeachTitle: "Wereldwijd zakendoen in beeld",
    homeTitleDetail:
      "CSI, een datagedreven onderzoeks- en IT-bureau, is gespecialiseerd in krediet, risico en big data. Het biedt digitale tools aan wereldwijde investeerders en zakelijke professionals, waarbij geavanceerde analyses en algoritmen worden gebruikt om snelle, visuele inzichten te bieden die slimmere besluitvorming mogelijk maken.",
    phoneTitleDetail:
      "Om snel bedrijfsinformatie te zoeken, bekijken en verkrijgen, kunt u ook de CSI-app op uw telefoon gebruiken",
    
    
      //未对应
    searchCompanyNum:
      "Search 500+ million companies in 200+ countries and territories",
    IndustryAnalysis: "Industry Analysis",
    BusinessAnalytics: "Business Analytics",
    ImportExportData: "Import-Export Data",
    CompanyNews: "Company News",
    Sanctions: "Sanctions",
    SearchLeads: "Search Leads",
    BusinessIntelligence: "Business Intelligence",
    CompanyIdentityVerification: "Company Identity Verification",
    KYCSolutions: "KYC Solutions",
    OwnershipPenetration: "Ownership Penetration",
    CompanyFinancialAnalysis: "Company Financial Analysis",
    CreditRatings: "Credit Ratings",
    CreditReports: "Credit Reports",
    ESGRatings: "ESG Ratings",
    VendorScreening: "Vendor Screening ",
    MarketResearch: "Market Research ",
  },
  Toolbar: {
    Filter: "Filter",
    Select: "Selecteren",
    Edit: "Bewerken",
    Sortby: "Sorteren op",
    Collect: "Verzamelen",
    Saved: "Opgeslagen",
    Compare: "Vergelijken",
    Export: "Exporteren",
    Download: "Downloaden",
    Update: "Bijwerken",
    Reporterror: "Fout melden",
    Share: "Delen",

    //未对应
    ascending: "ascending",
    descending: "descending",
    Customfolder: "Custom folder",
  },
  AiZaba: {
    //未对应
    whatareyousearchingfor: "What are you searching for?",
    CreditAnalyst: "Credit Analyst",
    Assesses:
      "Assesses a company'screditworthiness,identifiesfinancial risks,ensuring secure transactionsthrough data analysis andcredit ratings.",
    LegalAdvisor: "Legal Advisor",
    Provides:
      "Provides compliance guidance,reviews contracts,andassesseslegarisks to ensure businessoperations align with lawsand avoid disputes.",
    BizConsultant: "Biz Consultant",
    Optimizes:
      "Optimizes supply chains,identifiesbuyers, andboosts sales by analyzingmarket trends and offeringtailored strategies to improve efficiency",
    EconomicAnalyst: "Economic Analyst",
    Analyzes:
      "Analyzes industry and regional economic trendshelping businesses makeinformed decisions, and staycompetitive.",
  },
  navigationBar: {
    Notifications: "Meldingen", //通知
    MarkasRead: "Markeren als gelezen", //标记已读
    Viewall: "Alles bekijken", //查看全部
    SilverSubscriber: "Zilveren abonnee", //银级用户
    Silversubscriberdate: "Vervaldatum Zilver-abonnement", //银级到期日
    GoldSubscriber: "Gouden abonnee", //金级用户
    Goldsubscriptiondate: "Vervaldatum Goud-abonnement", //金级到期日
    AvailableCredits: "Beschikbare credits", //可用积分
    AddCredits: "Credits toevoegen", //购买积分
    IndivdualAccount: "Individueel account", //个人账号
    GroupAccount: "Groepsaccount", //集团账号
    //未对应
    OrdinaryUsers:"Ordinary users",
    UserAccount: "User Account",
    Roles: "Functies", //角色
  },
  ListofResults: {
    Country:'Land',
    Industry:'Branche',
    CompanyType:'Bedrijfstype',
    CompanySize:'Bedrijfsgrootte',
    CompanyStatus:'Bedrijfsstatus',
    CompanyName:'Bedrijfsnaam',
    CoType:'Bedrijfstype',
    RegStatus:'Reg. status',
    StateProvince:'Staat/Provincie',
    CityCounty:'Plaats/County',
    DistrictCity:'District/Stad',
    IncDate:'Inc. datum',
    LegalForm:'Rechtsvorm',
    CoID:'Bedrijfsnummer',
    TaxNo:'Btw-nummer',
    ListingInfo:'Vermeldingsgegevens',
    Phone:'Telefoon',
    Website:'Website',
    Email:'E-mail',
    LegalPerson:'Rechtspersoon',
    PostCode:'Postcode',
    ISIC:'ISIC',
    IndustryDescription:'Bedrijfsomschrijving',
    NACE:'NACE',
    NAICS:'NAICS',
    CreditRating:'Kredietbeoordeling',
    SolvencyIndex:'Solvabiliteitsindex',
    ProbabilityofDefault:'Kans op wanbetaling',
    NoofEmployees:'Aantal werknemers',
    Revenue:'Omzet',
    TotalAsset:'Totale activa',
    NetProfit:'Nettowinst',
    ROA:'ROA',
    ROE:'ROE',
    ShowMore:'Meer weergeven',

  //未对应
    SelectCountry: "Select Country",
    ClearAll: "Clear All",
    SelectIndustry: "Select Industry",
    ListedCompany: "Listed Company",
    YearsinBusiness: "Years in Business",
    Sharethisinformation: "Share this information",
    Pleaseaddress: "Please enter one or more email address",
    Example: "Example",
    message: "message",
    pleaseleaveamessage: "please leave a message",
    Include: "",
    thisaddress: "this company name,ID,address",
    CSIwebsite: "CSI website",
    Update: "Update",
    Iftheavailable:
      "If the available online data is insufficient or outdated, you can click the “Update” button to request an instant update for a fresh investigated business credit report from our local networking investigators or credit reporting agencies. The cost for this update is 1 credit per company. The update report typically takes between 24 and 72 hours to be delivered.",
    Abusinesscredit:
      "A business credit report provides detailed information about the subject company’s identification data, registry records, shareholding structure, company history, management description, related companies, actual operations, trade references, financial data and analysis, official public information such as litigation records and sanctions, and credit analysis and assessment.",
    Searchcompanies: "Search more emails on other companies",
  Rowsperpage:'Rows per page',
      Foundover:'Found over',
    results:'results',
    Remove:'Remove',
    Confirm:'Bevestigen',
    Rescan:'Rescan'
  },
  ContentTabs: {
    Background: "Achtergrond",
    BusinessActivities: "Bedrijfsactiviteiten",
    Performance: "Prestaties",
    Publications: "Publicaties",
    CreditOpinion: "Kredietoordeel",
    MarketAnalysis: "Marktanalyse",
    Snapshot: "Snapshot",
    Profile: "Profiel",
    Ownership: "Eigendom",
    RelatedCompanies: "Gerelateerde bedrijven",
    Management: "Management",
    Operations: "Operations",
    Locations: "Locaties",
    Industry: "Branche",
    ImportExport: "Import & Export",
    SupplyChain: "Toeleveringsketen",
    FinancialHighlights: "Financiële hoogtepunten",
    RatioAnalysis: "Ratioanalyse",
    IndustryNorm: "Branchenorm",
    News: "Nieuws",
    Sanctions: "Sancties",
    IndustryStatistics: "Branchestatistieken",
    RatingAnalysis: "Ratinganalyse",
    CompetitiveAnalysis: "Concurrentieanalyse",
  },
  Snapshot: {
    CompanyDQIdesc1:'The Data Quality Index (DQI) employs algorithms to assess different aspects of data, including completeness, validity, reliability of sources, consistency, timeliness, and bilingual support.',
    CompanyDQIdesc2:'The index is designed to assess the quality of data on a scale of 1 to 100, with higher scores indicating superior data quality. Algorithms can analyze data based on predefined rules or criteria, enabling objective and standardized measurements.',
    CompanyDQIdesc3:'Our Data Quality Index (DQI) serves as a reliable indicator, allowing users to quantitatively assess data quality. This enables data-driven decision-making and enhances the overall value and utility of the data.',
    CountryDQIdesc1:'The Data Quality Index (DQI) assesses the reliability, accuracy, and accessibility of data across countries, reflecting differences in digital infrastructure, governance, and transparency. Developed nations typically rank higher due to strong data systems, open policies, and advanced technology, while developing economies often struggle with gaps in infrastructure, regulation, or data-sharing practices.',
    CountryDQIdesc2:'Key factors include government transparency, data protection laws, and technological adoption. A high DQI enables better policymaking and business decisions, while a low score highlights areas needing investment.',
    CompanyDQI: "Bedrijfs-DQI", //公司数据质量指数 DQI
    CountryDQI: "Land-DQI", //国家数据质量指数 DQI
    CompanyTitle:'Data Quality Index (DQI) by Company',
    CountryTitle:'Data Quality Index (DQI) by Country',
     //未对应以上

    Address: "Adres", //地址
    CountyCity: "Graafschap/Stad", //县/市
    ProvinceState: "Provincie/Staat", //省/州
    CountryRegion: "Land/Regio", //国家/地区
    ZipCode: "Postcode", //邮政编码
    Website: "Website", //网站
    Email: "E-mail", //电邮
    Tel: "Tel.", //电话
    LastUpdate: "Laatste update", //最近更新
    DataSource: "Gegevensbron", //数据来源
    LegalStatus: "Rechtsstatus", //法定状况
    CoID: "Bedrijfs-ID", //公司ID
    CompanyType: "Bedrijfstype", //公司类型
    RegistrationDate: "Registratiedatum", //注册日期
    RegistrationStatus: "Registratiestatus", //注册状态
    Listed: "Geregistreerd", //上市信息
    CurrentOpperations: "Huidige activiteiten", //经营状况
    IndustryCode: "Branchecode", //行业代码
    BusinessActivities: "Bedrijfsactiviteiten", //主营业务
    NoofEmployees: "Aantal medewerkers", //员工数量
    NoofShareholders: "Aantal aandeelhouders", //股东数量
    Management: "Management", //管理状况
    Performance: "Prestaties", //业绩表现
    Revenue: "Omzet", //收入
    Assets: "Activa", //资产
    ProfitLoss: "Winst/verlies", //利润
    Growth: "Groei", //公司增长
    Competitiveness: "Concurrentievermogen", //竞争力
    CreditOpinion: "Kredietoordeel", //信用状况
    CreditRating: "Kredietbeoordeling", //信用评级
    CreditScore: "Kredietscore", //信用评分
    ESGRating: "ESG-beoordeling", //ESG 评级
    Solvency: "Solvabiliteit", //偿还能力
    Sanctions: "Sancties", //全球制裁
    CoName:"Bedrijfsnaam",
        //未对应
   RegName:"Reg. Name"
  },
  Profile: {
    CompareCompanies:'Compare Companies',//未对应
    AddaCompany:'Add a Company',//未对应
    CompanyProfile: "Bedrijfsprofiel", //基本资料
    CompanyName: "Bedrijfsnaam", //公司名称
    NativeName: "Oorspronkelijke naam", //当地名称
    CompanyID: "Bedrijfs-ID", //公司 ID
    VATNumber: "Btw-nummer", //VAT号
    StockCode: "Aandelencode", //股票代码
    Listed: "Geregistreerd", //上市日期
    RegistrationDate: "Registratiedatum", //注册日期
    LegalForm: "Rechtsvorm", //公司性质
    CompanyType: "Bedrijfstype", //公司类型
    LegalStatus: "Rechtsstatus", //注册状态
    Jurisdiction: "Jurisdictie", //司法管辖区
    RegisteredAddress: "Geregistreerd adres", //注册地址
    ProvinceState: "Provincie/Staat", //省/州
    CountryRegion: "Land/Regio", //国家/地区
    ZipCode: "Postcode", //邮政编码
    OperatingAddress: "Bedrijfsadres", //经营地址
    LastUpdate: "Laatste update", //最近更新
    DataSource: "Gegevensbron", //数据来源
    History: "Geschiedenis", //历史记录

    //未对应
    RegisteredCapital: "Registered Capital",
    PaidinCapital: "Paid-in Capital",
    CountyCity: "Graafschap/Stad",
  },
  Ownership: {
    UltimateBeneficiary: "Uiteindelijke begunstigde", //最终受益人
    InvolvingIndividuals: "Particulieren", //涉及自然人股东
    InvolvingEnterprises: "Ondernemingen", //涉及法人股东
    ShareholderLevel: "Aandeelhoudersniveau", //股东层级x
    Name: "Naam", //名称
    Country: "Land", //国家/地区
    Location: "Locatie", //地点
    Type: "Type", //类型
    Shares: "Aandelen", //股份
    Relation: "Relatie", //关系

    //未对应
    Individuals: "Individuals", //关系
    PartiesInvolved: "Parties Involved",
    RelatedCompany: "Related Company",
    CompanyShareholders: "Company Shareholders",
    NGOShareholders: "NGO Shareholders",
    NaturalPersonShareholder: "Natural Person Shareholder",
    SubjectInvestments: "Subject's Investments",
  },
  RelatedCompanies: {
    Total: "Totaal", //相关公司总计
    Entities: "Entiteiten", //法人实体
    Countries: "Landen", //国家/地区
    Branches: "Vestigingen", //分支机构
    RelatedComp: "Gerelateerde bedrijven", //关联公司
    Name: "Naam", //名称
    Country: "Land", //国家/地区
    Location: "Locatie", //地点
    Type: "Type", //类型
    Relation: "Relatie", //关系

    //未对应
    BranchOffices: "Branch Offices",
    Individuals: "Individuals",
  },
  Management: {
    Management: "Management", //管理层
    ContactInfo: "Contactgegevens", //联系人信息
    Countries: "Landen", //国家/地区
    Name: "Naam", //名称
    Position: "Functie", //职位
    Department: "Afdeling", //部门
    Country: "Land", //国家/地区
    ShareholderNot: "Aandeelhouder of niet", //是否股东
    Relation: "Relaties", //关系
    Verification: "Verificatie", //已验证
    Searchmoreemails: "Zoek meer e-mails", //搜索更多电邮
    Roles: "Functies", //角色
    EducationLevel: "Opleidingsniveau", //教育程度
    Phone: "Telefoon", //电话
    Email: "E-mail", //电邮
    Verified: "Geverifieerd", //已验证
    Searchmore: "Zoek meer e-mails van andere bedrijven", //搜索更多其他公司的电邮
    //未对应
    Pleaseentername:"Please enter name",
    PleaseenterWebsite:"Please enter Website",
    UserSelfVerification:"User Self Verification",
    Userverified:"User verified",
  },
  Operations: {
    Operations: "Operations",
    LineofBusiness: "Bedrijfstak", //业务范围
    BusinessTerritories: "Zakelijke gebieden", //业务区域
    ImportExport: "Import & Export", //进出口信息
    Viewtradeinfo: "Bekijk meer handelsinformatie", //查看更多贸易信息
    ProductsServices: "Producten/Diensten", //产品/服务
    Products: "Producten", //产品
    ProductImage: "Productafbeelding", //产品图片
    ProductName: "Productnaam", //产品名称
    ProductDescription: "Productomschrijving", //产品描述
    Details: "Details", //详情
    Addproductinformation: "Productinformatie toevoegen", //添加产品信息
    //未对应
    Showcaseyourcompany:"If you’d like to showcase your company’s products or services to the public, you can add your product and service information here. This is a great way to promote your business. Once we’ve reviewed your submission, your data will be published."
  },
  Locations: {
    CoName: "Bedrijfsnaam", //业务范围
    Relationship: "Relatie", //关系
    Type: "Type", //类型
    Country: "Land", //国家/地区
    Location: "Locatie", //地点
    Address: "Adres", //地址
    Edit: "Bewerken", //编辑
    CompanyLocatiionsMap: "Bedrijfslocaties op de kaart", //地图中的公司位置
    Selectaddresstype: "Adrestype selecteren", //选择地址类型
    Subjectcompany: "Onderwerp bedrijf", //目标公司
    Subsidiary: "Dochteronderneming", //子公司
    RegisteredAddress: "Geregistreerd adres", //注册地址
    OperationAddress: "Bedrijfsadres", //运营地址
    All: "Alles", //全部
    //未对应
    Showlocation :"Show location ",
  },
  Industry: {
    IndustryTitle: "Branchetitel", //IndustryTitle
    IndustryDescription: "Branchebeschrijving", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "ISIC-beschrijving", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "NACE-beschrijving", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "NAICS-beschrijving", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "CSIC-beschrijving", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "AAAIC-beschrijving", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "GICS-beschrijving", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Totaal importbedrag", //进口总额
    TopImportCountry: "Top importland", //最大进口国家/地区
    TopImportProduct: "Top importproduct", //最大进口产品
    TotalExport: "Totale export", //出口总额
    TopExportCountry: "Top exportland", //最大出口国家/地区
    TopExportProduct: "Top exportproduct", //最大出口产品
    TradeVolume: "Handelsvolume", //贸易额
    ImportShipments: "Importzendingen", //进口量
    ExportShipments: "Exportzendingen", //出口量
    ImportCountries: "Importlandens", //进口国家/地区
    ExportCountries: "Exportlanden", //出口国家/地区
    ImportVolume: "Importvolume", //进口量
    ExportVolume: "Exportvolume", //出口量
    TopSuppliers: "Topleveranciers", //主要供应商
    ByNumberofShipments: "Op aantal zendingen", //按出货量
    TopBuyers: "Topkopers", //主要买家
    ByNumberofShipments: "Op aantal zendingen", //按出货量
    ImportQuantity: "Importhoeveelheid", //进口数量
    IncreaseDecreasexRate: "Toename-/afnamepercentage", //增/减率
    ExportQuantity: "Exporthoeveelheid", //出口数量
    ImportsExportsRecords: "Import- en exportrecords", //进出口记录
    Date: "Datum", //日期
    Product: "Product", //产品
    HSCode: "HS-code", //HS 编码
    BuyerName: "Naam koper", //买家名称
    Destination: "Bestemming", //目的地
    SupplierName: "Naam leverancier", //供应商名称
    Origin: "Oorsprong", //原产地
    Amount: "Bedrag", //金额
    Details: "Details", //详情
    
    //未对应
    Imports: "Imports",
    Exports: "Exports",
    Shipments: "Shipments",
    value: "value",
    ByNumberofvalue: "By Number of value",
    viewmoretradeinfo: "view more trade info",
    SearchHSCode:"Search HS Code",
  },
  SupplyChain:{
  //未对应
    Illustratesthesubjectcompany:"This chart illustrates the subject company’s “buy from” and “sell to” relationships. The larger the volume, the thicker the tube.",
},
  ShippingOrderDetails: {
    Date: "Datum",
    MasterBillofLading: "Master Bill of Lading",
    Source: "Bron",
    BillNo: "Factuurnummer",
    ImporterBuyer: "Importeur/koper",
    ExporterSeller: "Exporteur/verkoper",
    Name: "Naam",
    Address: "Adres",
    Country: "Land",
    Contact: "Contactpersoon",
    Email: "E-mailadres",
    CargoInfo: "Ladinginformatie",
    HSCode: "HS-code",
    Quantity: "Hoeveelheid",
    WeightUnit: "Gewichtseenheid",
    ProductDescription: "Productomschrijving",
    Amount: "Hoeveelheid",
    QuantityUnit: "Hoeveelheidseenheid",
    Weight: "Gewicht",
    HSDescription: "HS-omschrijving",
    Incoterms: "Incoterms",
    ShippingInfo: "Verzendinformatie",
    Vessel: "Schip",
    Consignee: "Geadresseerde",
    MeansofTransport: "Vervoermiddel",
    CountryofOrigin: "Land van herkomst",
    Voyage: "Reis",
    Notifier: "Kennisgever",
    CountryofDestnation: "Land van bestemming",
    AddressofOrigin: "Adres van herkomst",
    Shipper: "Verzender",
    AddressofDestnation: "Adres van bestemming",
    Container: "Container",
    ContainerID: "Container-ID",
    ContainerType: "Containertype",
    ContainerDescDode: "Containeromschrijving",
    ContainerSize: "Containergrootte",
    ImportExport: "Importer / Exporter",//未对应
  },
  FinancialHighlight: {
    Revenue: "Omzet", //收入
    Profit: "Winst", //利润
    Growth: "Groei", //增长
    FinancialStructure: "Financiële structuur", //融资结构
    CreditOpinion: "Kredietoordeel", //信用评估
    RiskIndicator: "Risico-indicator", //风险指标
    Solvencyindex: "Solvabiliteitsindex", //偿还指数
    Year: "Jaar", //年份
    Change: "Verandering", //变化
    NetProfit:"Nettowinst",
    TotalAssets:"Totale activa",
    Equity:"Eigen vermogen",
    GrossMargin:"Brutomarge",
    ProfitMargin:"Winstmarge",
    ReturnonEquity:"Rendement op eigen vermogen",
    CurrentRatio:"Current ratio",
    DebtRatio:"Schuldratio",
    FinancialHighlights: "Financiële gegevens van de gerelateerde bedrijven", //关联公司财务数据
    FinancialHighlightsTitle:
      "Financiële hoogtepunten van de gerelateerde bedrijven", //关联公司财务摘要
    CompanyName: "Bedrijfsnaam", //公司名称
    CompanyID: "Bedrijfs-ID", //公司ID
    Country: "Land", //国家/地区
    CompanyStatus: "Bedrijfsstatus", //公司状态
    Relations: "Relaties", //关系
    Cancel: "Annuleren", //取消
    Select: "Selecteren",
   Liquidity:'Kasstroomstatus',//现金流状况
    RatioAnalysis: "Ratioanalyse van de gerelateerde bedrijven",
    //未对应
    Financialperformancedata:"Financial performance data is collected from various governmental sources and local credit reporting agencies. Additionally, market and industry research is used to calculate and model the data. For more detailed information about the actual operations and performance analysis, please contact our service team to request a company due diligence report.",
    Whenthesubjectsdata:"When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    Byprovidingyou:"By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    PleaseSelectTheYeartoDisplay:"Please Select The Year to Display",
    SelectUptoThreeYears:"Select Up to Three Years",
  },
  RatioAnalysis: {
    ProfitabilityRatios:"Winstgevendheidsratio's",
    Year:'Jaar',
    Change:'Verandering',
    Returnonequity :'Rendement op eigen vermogen',
    Returnonassets:'Rendement op activa',
    Profitmargin:'Winstmarge',
    Grossmargin:'Brutomarge',
    OperatingRatios:"Operationele ratio's",
    Assetsturnover:'Omloopsnelheid activa',
    Stockturnover:'Omloopsnelheid voorraad',
    Salesperiod:'Verkoopperiode',
    Collectionperiod:'Incassoperiode',
    Creditperiod:'Kredietperiode',
    StructuralRatios:"Structurele ratio's",
    Currentratio:'Current ratio',
    Quickratio:'Quick ratio',
    Shareholdersliquidityratio:'Liquiditeitsratio aandeelhouders',
    Solvencyratio:'Solvabiliteitsratio',
    Debtratio:'Schuldratio',
    ProductivityRatios:"Productiviteitsratio's",
    Profitperemployee:'Winst per werknemer',
    Operatingrevenueperemployee:'Bedrijfsopbrengsten per werknemer',
    Shareholdersfundsperemployee:'Eigen vermogen per werknemer',
    Totalassetsperemployee:'Totale activa per werknemer',
    GrowthRatios:"Groeiratio's",
    Salesgrowthrate:'Omzetgroei',
    Netprofitgrowthrate:'Groei van de nettowinst',
    Totalassetsgrowthrate:'Groei van de totale activa',
    FinancialHighlights:'Financiële gegevens van de gerelateerde bedrijven',//关联公司财务数据
    RatioAnalysis:'Ratioanalyse van de gerelateerde bedrijven', //关联公司比率分析
    CompanyName:'Bedrijfsnaam',
    CompanyID:'Bedrijfs-ID',
    Country:'Land',
    CompanyStatus:'Bedrijfsstatus',
    Relations:'Relaties'    
},
  IndustryNorms: {
    IndustryStatistics: "Branchestatistieken",
    ofcompaniesintheIndustry: "Aantal bedrijven in de branche",
    oflistedCompaniesintheIndustry:
      "Aantal beursgenoteerde bedrijven in de branche",
    oflargecompaniesintheIndustry: "Aantal grote bedrijven in de branche",
    ofSMEsintheIndustry: "Aantal mkb-bedrijven in de branche",
    ofcompaniesinsample: "Aantal bedrijven in de steekproef",
    ofcompaniesinloss: "Aantal bedrijven met verlies",
    Observations: "Observaties",
    AverageValue: "Gemiddelde waarde",
    MedianValue: "Mediaanwaarde",
    MaximumValue10: "Maximale waarde 10%",
    MinimumValue10: "Minimale waarde 10%",
    SubjectCompany: "Onderwerp",
    YearsinBusiness: "Bedrijfsjaren",
    TotalAssets: "Totale activa",
    TotalEquity: "Totaal eigen vermogen",
    Revenue: "Omzet",
    NetEarning: "Nettowinst",
    Returnonassets: "Rendement op activa",
    Performance: "Prestaties",
    ProfitabilityRatios: "Winstgevendheidsratio's",
    Returnonequity: "Rendement op eigen vermogen",
    Returnonassets: "Rendement op activa",
    Grossmargin: "Brutomarge",
    OperatingRatios: "Operationele ratio's",
    Stockturnover: "Omloopsnelheid van de voorraad",
    Accountsreceivableturnover: "Omloopsnelheid van debiteuren",
    Assetsturnover: "Omloopsnelheid van activa",
    Totalassetturnover: "Omloopsnelheid van totale activa",
    StructuralRatios: "Structuurratio's",
    Currentratio: "Current ratio",
    Quickratio: "Quick ratio",
    Shareholdersliquidityratio: "Liquiditeitsratio aandeelhouders",
    GrowthRatios: "Groeiratio's",
    Salesgrowthrate: "Omzetgroei",
    Netprofitgrowthrate: "Groeisnelheid van de nettowinst",
    Totalassetsgrowthrate: "Groeisnelheid van totale activa",
  },
  Lawsuits:{
  //未对应
    Lawsutis: "Lawsutis",
    Date: "Date",
    CaseCategory: "Case Category",
    Title: "Title",
    CaseNo: "Case No.",
    CauseofAction: "Cause of Action",
},
  News: {
    Date: "Datum", //日期
    Title: "Titel", //标题
    Source: "Bron", //来源
    Impact: "Impact", //影响
    Searchcompanies: "Zoek meer nieuws over andere bedrijven", //国家/地区
    //未对应
    SearchforTitle:"Search for Title",
  },
  Sanctions: {
    Potentialcompliance: "Er zijn potentiële compliancerisico's gedetecteerd", //检测到潜在合规风险
    SeachbuttonNo: "Er is niets nadeligs gedetecteerd over dit bedrijf", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      'Klik op de knop "Sancties zoeken" om meer sanctiegegevens te krijgen.', //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Sancties zoeken", //搜索制裁
    ViewDetails: "Details bekijken", //查看详情
    Sanctions: "Sancties", //制裁
    Potentialcompliancerisks: "Potentiële compliancerisico's", //潜在合规风险
    IDInfo: "ID-info", //ID 信息
    IDType: "ID-type", //ID 类型
    IDDescription: "ID-beschrijving", //ID 描述
    SanctionList: "Sanctielijst", //制裁名单
    SanctionListInvolved: "Betrokken sanctielijst", //涉及的制裁名单
    StartDate: "Startdatum", //生效日期
    EndDate: "Einddatum", //结束日期
    SourceList: "Bronlijst", //来源名单
    SourceName: "Bronnaam", //来源名称
    ProfileNotes: "Profielnotities", //主体资料
    Link: "Link", //链接
    Name: "Naam", //名称
    //未对应
    AssociationList:"Association List",
    AssociationID:"Association ID",
    AssociationType:"Association Type",
  },
  CreditOpinion: {
    CreditAssessment: "Kredietbeoordeling",
    CreditAssessmentfromtheRelatedCompanies:
      "Kredietbeoordeling van de gerelateerde bedrijven",
    Year: "Jaar",
    CreditRating: "Kredietwaardigheid",
    LocalCreditScore: "Lokale kredietscore",
    ProbabilityofDefault: "Kans op wanbetaling",
    SolvencyIndex: "Solvabiliteitsindex",
    CreditLine: "Kredietlimiet",
    RiskIndicator: "Risico-indicator",
    RelatedCreditAssessment: "Gerelateerde kredietbeoordeling",
    CompanyName: "Bedrijfsnaam",
    CompanyID: "Bedrijfs-ID",
    Country: "Land",
    CompanyStatus: "Bedrijfsstatus",
    Relations: "Relaties",
    Cancel: "Annuleren", //取消
    Select: "Selecteren",
        //未对应
    LocalCreditScore: "Local Credit Score",
    SolvencyIndex: "Solvency Index",
    ProbabilityofDefault: "Probability of Default",
    RiskIndicator: "Risk Indicator",
   CreditAssessmentMessage1:
      "When the subject’s data is insufficient, or you’re interested in gaining more insights into your customer, this platform offers a comprehensive view of all entities related to the subject. This includes the subject’s company’s shareholders, related companies, and more.",
    CreditAssessmentMessage2:
      "By providing you with a broader perspective, this platform empowers you to make more informed evaluations and gain a deeper understanding of your subject.",
    LocalCreditRating: "Local Credit Rating",
    LocalCreditRatingDetail:
      "Driven by the power of big data, 3ARating is a quantitative rating system for private companies. It is a collaborative effort between 3ACredit and Creditreform Rating. The rating model is built based on a comprehensive evaluation of various key factors, including non-financial factors, financial factors, negative records, and industry-specific considerations. The rating model exhibits an impressive Gini coefficient, indicating its robustness and reliability. 3ARating spans a range of ratings, from the highest rating, 3A1, to the lowest rating class, 3A19.",
    CreditScore: "Credit Score",
    CreditScoreDetail:
      "Credit scores are calculated on a scale from 1 to 100, based on the credit rating obtained from local authorities. A higher score indicates better creditworthiness.",
    PossibilityofDefault: "Possibility of Default (PD)",
    PossibilityofDefaultDetail:
      "The Possibility of Default (PD) is a useful tool for risk assessment, focusing on short-term liquidity evaluation.",
    SolvencyIndexSI: "Solvency Index (SI)",
    SolvencyIndexSIDetail:
      "The Solvency Index (SI) is a highly effective and reliable early warning indicator that allows for a rapid assessment of the solvency of business partners. A higher SI value indicates a higher risk of default by a client. The SI ranges from 100, which is considered an excellent rating, to 600, where highly negative characteristics are present.",
    ExternalRating: "External Rating",
    DefaultProbability: "Default Probability(Pd1Year)",
    Rating:"3ARating (>=,<=)",
    PleaseSelectTheYeartoDisplay:"Please Select The Year to Display",
    SelectUptoThreeYears:"Select Up to Three Years",
  },
  IndustryStatistics: {
    SubjectCompany: "Onderwerp Bedrijf",
    Country: "Land",
    Compare: "Vergelijken",
    Industry: "Branche",
    CompanyType: "Bedrijfstype",
    CompanySize: "Bedrijfsgrootte",
    CompanyStatus: "Bedrijfsstatus",
    YearsinBusiness: "Jaren actief",
    CompanyRating: "Bedrijfsbeoordeling",
    Liquidity: "Kasstroomstatus",
            //未对应
    NoofcoinIndustry: "No. of co. in Industry",
    IndustryRating: "Industry Rating",
    Profitability: "Profitability",
    Repaying: "Repaying",
    SearchCountry: "Search Country",

    Growth: "Groei",
    FinancialStructurt: "Financiële structuur",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Brancheanalyse",
    GeographicAnalysis: "Geografische analyse",
    CompanyTypeAnalysis: "Analyse bedrijfstype",
    BiusinessScaleAnalysis: "Analyse bedrijfsschaal",
    HistoryAnalysis: "Historische analyse",
    NormalDistribution: "Normale verdeling",
    SubjectCompany: "Onderwerpbedrijf",
    Probabilityofthesubjectratinginitsindustry:
      "Waarschijnlijkheid van beoordeling van het onderwerp in zijn branche",
    Maximum: "Maximaal 10%",
    Mean: "Gemiddelde",
    Average: "Gemiddelde",
    Minimum: "Minimaal 10%",
    RatingDistribution: "Beoordelingsverdeling",
    Revenue: "Omzet",
    Earning: "Winst",
    TotalAssets: "Totale activa",
    Subjectratinginitsindustrybyfinancialindicators:
      "Beoordeling van het onderwerp in zijn branche op basis van financiële indicatoren",
    Best: "Beste",
    Worst: "Slechtste",
    Rankingofsubject:
      "Rangschikking van de beoordeling van het onderwerp in de branche",
    Industy: "Branche",
    Percentilerank:
      "Percentielrangschikking: % bedrijven met een score gelijk aan of lager dan de beoordeling van het onderwerp",
    Historicaldevelopmentofsubject:
      "Historische ontwikkeling van de beoordeling van het onderwerp in zijn branche",
    IndustryAverage: "Gemiddelde in de branche",
    SubjectRatingChanges: "Wijzigingen in beoordeling van het onderwerp",
    CompanySize:'Bedrijfsgrootte',
    YearsinBusiness: "Jaren actief",
    //未对应
    CreditScore:"Credit Score",
    NOofCompanies:"NO. of Companies",
    ofCompanies:"% of Companies",
    CreditRating:"Credit Rating",
    SubjectsIndustryConcentrationAnalysis:"Subject's Industry Concentration Analysis",
    GeographicdistributionofSubjectsratingintsindustry:"Geographic distribution of Subject's rating in its industry",
    GeographicdistributioninSubjectindustry:"Geographic distribution in Subject's industry：",
    RatingDistributioninSubjectsLocation:"Rating Distribution in Subject's Location",
    Ratinganalysisofcompanies:"Rating analysis of companies in the same industry with different years in business",
    Subjectsratinghistory:"Subject's rating history comparing with its peers with the same history",
    Ratingrankingofcompanieswithsamehistory:"Rating ranking of companies with same history",
    Ratingstatistics:"Rating statistics of companies with the same years in business",
    Subjectratingcomparing:"Subject rating comparing with its peer companies with the",
    Subjectratinginitsgroup:"Subject rating in its group:",
    Analysisbasedonnature:"Analysis based on nature of companies in subject's industry",
    Subjectratingpositioninitscompanytype:"Subject rating position in its company type:",
    Ratingstatisticsofcompanies:"Rating statistics of companies in the same industry",
    Ratinganalysisofcompanies:"Rating analysis of companies of different sizes in the same industry",
    Probabilityofsubjectrating:"Probability of subject rating in its industry within its size",
    Subjectratingcomparingwithindustry:"Subject rating comparing with its peers in its industry:",
    RatingRankingofthecompanies:"Rating Ranking of the companies in the same size in the same industry",
    Ratingstatisticsofcompanies:"Rating statistics of companies in the same size and same industry",
    Rank:"Rank",
    Rating:"Rating",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Marktpositie",
    Revenus: "Omzet",
    NetEarnings: "Nettowinst",
    NetAssets: "Nettoactiva",
    TotalAssets: "Totale activa",
    Employees: "Medewerkers",
    Mean: "Gemiddelde",
    Average: "Gemiddelde",
    Maximum: "Maximum (10%)",
    Worst: "Slechtste (10%)",
    Subjectcompany: "Onderwerpbedrijf",
    PerformanceComparison: "Prestatievergelijking",
    ProfitabilityRatios: "Winstgevendheidsratio's",
    Grossmargin: "Brutomarge",
    Returnonassets: "Rendement op activa",
    Returnonequity: "Rendement op eigen vermogen",
    OperatingRatios: "Operationele ratio's",
    Stockturnover: "Voorraadomloopsnelheid",
    Assetsturnover: "Activaomloopsnelheid",
    Collectionperiod: "Incassoperiode",
    GrowthRatios: "Groeiratio's",
    Totalassetsgrowthrate: "Groeipercentage totale activa",
    Salesgrowthrate: "Omzetgroeipercentage",
    Netprofitgrowthrate: "Groeipercentage nettowinst",
    StructuralRatios: "Structuurratio's",
    Debtratio: "Schuldratio",
    Quickratio: "Quick ratio",
    Currentratio: "Current ratio",
  },
  AccountCenterMenu: {
    SearchinSettings: "Zoeken in Instellingen", //在“设置”中搜索
    Account: "Account", //账户
    MyAccount: "Mijn account", //我的账户
    ContactInfo: "Contactgegevens", //联系信息
    AccountSecurity: "Accountbeveiliging", //账户安全
    OrganizationalManagement: "Organisatiebeheer", //组织管理
    UserGroup: "Gebruikersgroep", //用户组
    User: "Gebruiker", //用户
    Role: "Rol", //角色
    MyDatabase: "Mijn database", //我的数据库
    MyUsage: "Mijn gebruik", //我的使用情况
    CompaniesViewed: "Bekeken bedrijven", //查看过的公司
    ReportsDownloaded: "Gedownloade rapporten", //下载的报告
    ReportUpdatesOrdered: "Bestelde rapportupdates", //订购的报告更新
    BillingandPayment: "Facturering en betaling", //账单和付款
    BillRecords: "Rekeninggegevens", //账单记录
    PaymentRecords: "Betalingsgegevens", //付款记录
    CreditDeductions: "Creditaftrek", //信用扣款
    InvoicesDownloaded: "Gedownloade facturen", //下载的发票
    UserSettings: "Gebruikersinstellingen", //用户设置
    Messages: "Berichten", //消息
    Notifications: "Meldingen", //通知
    HelpCenter: "Helpcentrum", //帮助中心
    FAQ: "Veelgestelde vragen", //常见问题
    Privacy: "Privacy", //隐私
    Terms: "Voorwaarden", //条款
    ReportIssues: "Problemen melden", //报告问题
    UserGuide: "Gebruikershandleiding", //用户指南
    AboutCSI: "Over CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Inlogtijd", //登录时间
    SignOut: "Afmelden", //退出
    DeleteAccount: "Account verwijderen", //删除账户
    AccountID: "Account-ID", //账户ID
    Enteranewaddress: "Voer een nieuw e-mailadres in", //输入新的电邮
    EnterVerificationCode: "Voer verificatiecode in", //输入验证码
    SendverificationCode: "Verificatiecode verzenden", //发送验证码
    Password: "Wachtwoord", //密码
    Originalpassword: "Oorspronkelijk wachtwoord", //原始密码
    Newpassword: "Nieuw wachtwoord", //新密码
    Confirmnewpassword: "Bevestig nieuw wachtwoord", //确认新密码
    AccountOwnership: "Accounteigendom", //账户所有权
    IndividualAccount: "Individueel account", //个人账户
    GroupAccount: "Groepsaccount", //集团账户
    Organizationname: "Organisatienaam", //机构名称
    CountryRegion: "Land/Regio", //国家/地区
    Address: "Adres", //地址
    City: "Plaats", //城市
    ZipCode: "Postcode", //邮政编码
    FirstName: "Voornaam", //名字
    LastName: "Achternaam", //姓氏
    PhoneNumber: "Telefoonnummer", //电话号码
    Email: "E-mailadres", //更改
    Change: "Wijzigen", //更改
    Save: "Opslaan", //保存
    Cancel: "Annuleren", //取消
    LastLogin: "Laatste aanmelding", //Last Login
    RecentLogin: "Recente aanmelding", //登录尝试次数
    AverageLoginTime: "Gemiddelde inlogtijd", //平均登录时间
    TotalLoginAttempts: "Totaal aantal inlogpogingen", //登录尝试次数
    //未对应
    Registrationtime:"Registration time",
    Role: "Ruolo",
    Administrator:"Administrator",
    Enterpriseusers:"Enterprise users",
    EditImage:"Edit Image",
    DeleteImage:"Delete Image",
  },
  ContactInfo: {
    ContactInfo: "Contactgegevens",
    FirstName: "Voornaam",
    LastName: "Achternaam",
    PhoneNumber: "Telefoonnummer",
    Email: "E-mailadres",
    CountryRegion: "Land/Regio",
    AddressLine: "Adresregel",
    City: "Plaats",
    ZipCode: "Postcode",
    Alternativecontactperson: "Alternatieve contactpersoon",
    Setascontactperson: "Instellen als contactpersoon",
    Edit: "Bewerken",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Stel mijn beveiligingsvragen in",
    Pleasechooseaquestion: "Kies een vraag",
    Pleaseentertheanswertothequestion: "Voer het antwoord op de vraag in",
    SessionTimeoutAutomaticLogoutSettings:
      "Sessie-time-out: Instellingen voor automatisch uitloggen",
    Thesystemwillautomatically:
      "Het systeem logt u automatisch uit na een periode van inactiviteit. De standaardtime-out is ingesteld op 5 minuten, maar u kunt deze duur naar wens aanpassen.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Totaal aantal gezochte bedrijven",
    TotalNumberofCompaniesCollected: "Totaal aantal verzamelde bedrijven",
    TotalNumberofUpdateReportsOrdered: "Totaal aantal bestelde updaterapporten",
    Date: "Datum",
    UserName: "Gebruikersnaam",
    CompanyName: "Bedrijfsnaam",
    Status: "Status",
    UsageType: "Gebruikstype",
    Entercompanyname: "Voer de bedrijfsnaam in",
    Download: "Downloaden",
  },
  OrganizationalManagement: {
    GroupName: "Groepsnaam",
    ParentGroupName: "Naam bovenliggende groep",
    Organization: "Organisatie",
    GroupID: "Groeps-ID",
    GroupStatus: "Groepsstatus",
    Operation: "Bewerking",
    NewlyBuilt: "Nieuw aangemaakt",
    UserAccount: "Gebruikersaccount",
    Role: "Rol",
    AccountStatus: "Accountstatus",
    RoleName: "Rolnaam",
    Position: "Positie",
    RoleStatus: "Rolstatus",
    Valid: "Geldig",
    Invalid: "Ongeldig",
    PermissionSettings: "Instellingen",
    Search:'Zoeken',
    Cancel:'Annuleren',
    Confirm:'Bevestigen',
    //未对应
    NewGroup:"New Group",
    EnterGroupName:"Enter Group Name",
    NumberofGroups:"Number of Groups",
    Groups:"Groups",
    Roles: "Functies",
    NewRoles:"New Roles",
    EnterNewRole:"Enter New Role",
    Users:"Users",
    EnterUserName:"Enter User Name",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Totaal aantal bestellingen",
    TotalPaymentAmount: "Totaal betaald bedrag",
    TotalDeductionCredits: "Totaal afgetrokken credits",
    Date: "Datum",
    UserAccount: "Gebruikersaccount",
    CompanyName: "Bedrijfsnaam",
    OrderNo: "Ordernummer",
    OrderType: "Ordertype",
    OrderStatus: "Orderstatus",
    Download: "Downloaden",
    PaymentAmount: "Betaalbedrag",
    Contactus: "Contact",
    DownloadInvoice: "Factuur downloaden",
    CreditsDeducted: "Afgetrokken credits",
    ReportOrderStatus: "Orderstatus rapporteren",
    CompanyID: "Bedrijfs-ID",
    CountryRegion: "Land/Regio",
    AddressLine: "Adresregel",
    City: "Plaats",
    ZipCode: "Postcode",
    FirstName: "Voornaam",
    LastName: "Achternaam",
    PhoneNumber: "Telefoonnummer",
    Email: "E-mailadres",
    BankAccountHolderName: "Naam bankrekeninghouder",
    BeneficiaryBankName: "Naam begunstigde",
    SWIFTCODE: "SWIFT-CODE",
    AccountNumber: "Rekeningnummer",
    BeneficiaryBankAddress: "Adres bank begunstigde",
    ABA: "ABA (routingnummer)",
    IBANnumber: "IBAN-nummer",
    //未对应
    StartingMonth:"Starting Month",
    EndMonth:"End Month",
  },
  UserSettings: {
    LanguageandLocation: "Taal en locatie",
    Language: "Taal",
    Selectyourpreferedlanguage: "Selecteer uw voorkeurstaal",
    Location: "Locatie",
    Selectyourlocation: "Selecteer uw locatie",
    NotificationSetting: "Meldingsinstellingen",
    EmailNotification: "E-mailmeldingen",
    ServiceUpdates: "Service-updates",
    CompanyNews: "Bedrijfsnieuws",
  },
  AddCredit: {
  //未对应
    Customizeyourplan: "Customize your plan however you need",
    Silver: "Silver",
    Gold: "Gold",
    Enterpris: "Enterpris",
    Credit: "Credit",
    Remaining: "Remaining",
    Points: "points",
    Usermonth: "user/ month",
    Useryear: "user/ year",
    PaidMonthlyRenews: "Paid monthly, no need for auto renews",
    PaidAnnuallyRenews: "Paid annually, no need for auto renews",
    ForFullSupport: "for full support to your needs",
    Each: "each",
    CreditsCharged:
      "Credits charged to your account will never expire as long as your account remains active.",
    PaidMonthly: "Paid monthly",
    PaidAnnually: "Paid annually",
    BuyNow: "Buy now",
    ContactNow: "Contact now",
    SearchCompanies:
      "Search companies and get an instant access to company data that includes:",
    EverythinginSilverPackage: "Everything in Silver package, plus:",
    CreditsCanbeUsed:
      "Credits can be used for more data services including the followings:",
    UnlimitedAdvancedSearch: "Unlimited advanced search",
    ViewCompanyProfile: "View company profile",
    CompanyOwnershipStructure: "Company ownership structure",
    CompanyFamilyTree: "Company family tree",
    Companymanagement: "Company management",
    CompanyContactsinfo: "Company contacts info",
    BusinessActivities: "Business activities",
    IndustryBasics: "Industry basics",
    ImportExportRecords: "Import & export records",
    CompanyPublications: "Company publications",
    CompanyNews: "Company news",
    DownloadOnlineReport: "Download online report",
    ManagementDetails: "Management details",
    ShareholderPenetration: "Shareholder penetration (UBO)",
    Financialinfo: "Financial info",
    FinancialAnalysis: "Financial analysis",
    CreditAssessment: "Credit assessment",
    IndustryAnalysis: "Industry analysis",
    MarketAnalysis: "Market analysis",
    SupplyChaininfo: "Supply Chain info",
    CheckSanctions: "Check sanctions",
    CompanyComparison: "Company comparison",
    DataExport: "Data export",
    MonitoringService: "Monitoring service",
    DiscountForFreshUpdateReports: "Discount for fresh update reports",
    SearchCompany: "Search Company",
    SearchLeads: "Search Leads",
    SearchTrade: "Search Trade",
    SearchPeople: "Search People",
    SearchCountry: "Search Country",
    SearchNews: "Search News",
    SearchSanction: "Search Sanction",
    DataServices: "Data Services",
    APIPlans: "API Plans",
    VolumeDiscounts: "Volume Discounts",
    GroupAccountsWithMultipleUsers: "Group Accounts with multiple users",
    CustomizedPlans: "Customized Plans",
    FreshInvestigatedCreditReportsWorldwide:
      "Fresh investigated credit reports worldwide",
    BusinessMonitoringServices: "Business monitoring services",
    BusinessProcessVerificationServices:
      "Business process verification services",
    VendorComplianceReports: "Vendor compliance reports",
    MarketResearch: "Market research",
    More: "More…",
    Contactus: "Contact us",
    PaymentMethod:"Payment Method",
    CreditCardNumber:"Credit Card Number",
    EnterCardNumber:"Enter Card Number",
    ExpirationDate:"Expiration Date",
    Fullnameoncard:"Full name on card",
    EnterFullname:"Enter Full name",
    EnterProvinceState:"Enter Province / State",
    CVCCode:"CVC Code",
    EnterCVCCode:"Enter CVC Code",
    IncorrectCreditCardNumberformat :"Incorrect Credit Card Number format ",
    IncorrectExpMonthformat:"Incorrect Exp.Month format",
    IncorrectExpYearformat:"Incorrect Exp.Year format",
    IncorrectFullNameformat:"Incorrect Full Name format",
    IncorrectCountryformat:"Incorrect Country format",
    IncorrectProvinceStateformat:"Incorrect Province / State format",
    IncorrectCVCCodeformat:"Incorrect CVC Code format",
    TotalPurchase:"Total Purchase",
    Agree1: "By clicking “Submit”, you agree to the ",
    Agree2:"CSI Services Agreement and Privacy .",
    Submit:"Submit",
    Month:"Month",

    Year: "Jaar",
    Country: "Land",
    ProvinceState: "Provincie/Staat",
    Cancel: "Annuleren",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Welke soorten fouten meldt u?",
    Tellusmoreaboutyourproblems: "Vertel ons meer over uw problemen.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Wilt u een screenshot of een bestand met betrekking tot uw probleem meesturen?",
    Fillinyourcontactinformation: "Vul uw contactgegevens in",
    FirstName: "Voornaam",
    LastName: "Achternaam",
    PhoneNumber: "Telefoonnummer",
    Email: "E-mailadres",
    Edit: "Bewerken",
  },
    //Risk Scan
RiskScan:{
  RiskScan:"Risk Scan",
  RiskScanInfo:" is uw alles-in-één platform voor uitgebreide bedrijfsrisico-informatie. We bieden gedetailleerde analyses voor elke belangrijke risicocategorie om uw zakelijke beslissingen te waarborgen.",
  LegalRisk:"Juridisch risico",
  LegalRiskInfo:"controleer de legitimiteit van het bedrijf",
  OrganizationalRisk:"Organisatorisch risico",
  OrganizationalRiskInfo:"stabiliteit van het management, complexiteit van de bedrijfsstructuur en transparantie van het eigendom.",
  OperationalRisk:"Operationeel risico",
  OperationalRiskInfo:"kwetsbaarheden in de toeleveringsketen, operationele status en geopolitieke blootstelling.",
  FinancialRisk:"Financiële prestatierisico's",
  FinancialPerformanceRiskInfo:"winstgevendheidstrends, liquiditeitsproblemen en de gezondheid van de balans.",
  CreditRisk:"Kredietrisico",
  CreditRiskInfo:"kredietwaardigheid, betalings-verleden en kans op wanbetaling.",
  ComplianceRisk:"Compliancerisico",
  ComplianceRiskInfo:"naleving van sancties, AML-regelgeving en branchespecifieke wetten",
  SustainabilityRisk:"Duurzaamheidsrisico",
  SustainabilityRiskInfo:"ESG-factoren (milieu, maatschappij, bestuur) en reputatieschade.",
  IndustryRisk:"Brancherisico",
  IndustryRiskInfo:"beoordeelt de stabiliteit en vooruitzichten van de gehele sector van een bedrijf.",
  LetBegin:"Laten we beginnen",
  AddcompaniesfromSearchResult:"Bedrijven toevoegen vanuit het zoekresultaat",
  AddcompaniesfromMyDatabase:"Bedrijven toevoegen vanuit Mijn Database",
  Addcompaniesbyuploadmyownlist:"Bedrijven toevoegen door mijn eigen lijst te uploaden",
  Cancel:"Annuleren",
  Confirm:"Bevestigen",
  UploadFiles:"Bestanden uploaden",
  PleaseuploadyourfileinCVSformat:"Upload uw bestand in xlsx-formaat.",
  Downloadxlsxtemplate:"xlsx-sjabloon downloaden",
  //语序问题未对应
  Xcompanieswereuploadedsucessfuly:"companies were uploaded sucessfuly.",
  Xcompanieswereidentifiedsucessfuly:"companies were identified sucessfuly.",
  Xcompanieswerenotmatched:"companies were not matched.",
  
  Uploadingfilefailed:"Uploaden van bestand mislukt. Gebruik het sjabloon en probeer het opnieuw.",
  ALL:"Alles",
  SearchLeads:"Zoek prospects",
  LastUpdate:"Laatste update",
  CompanyID:"Ondernemings-ID",
  CompanyType:"Bedrijfstype",
  RegistrationDate:"Registratiedatum",
  RegistrationStatus:"Registratiestatus",
  Listed:"beursgenoteerd",
  LegalStatus:"Rechtspositie",
  NoofShareholders:"Aantal aandeelhouders",
  ShareholdingLayers:"Aandeelhouder niveaus",
  NoofCorporateShareholders:"Aantal aandeelhouders van ondernemingen",
  NoofNatualPersonShareholders:"Aantal natuurlijke personen als aandeelhouders",
  RelatedCompanies:"Gerelateerde bedrijven",
  OrganizationalStatus:"Organisatiestatus",
  OperatingAddress:"Bedrijfsadres",
  IndustryCode:"Industriecode",
  BusinessActivities:"Bedrijfsactiviteiten",
  NoofEmployees:"Aantal werknemers",
  Management:"Management",
  CurrentOperations:"Huidige activiteiten",
  Revenue:"omzet",
  Assests:"Activa",
  ProfitLoss:"Winst/verlies",
  Liquidity:"Liquiditeit",
  Growth:"groei",
  Performance:"Bedrijfsprestaties",
  CreditRating:"Krediet rating",
  CreditScore:"Kredietscore",
  PausibilityofDefault:"Pausibiliteit van wanbetaling (PD)",
  SolvencyIndex:"Solvabiliteitsindex",
  DebtCollection:"incasso",
  CreditOpinion:"Kredietmening",
  CompanySanction:"Bedrijfssancties",
  ProductSanction:"Productsanctie",
  ExportControl:"Exportcontrole",
  AntiCorruptionAntiBribery:"Anti-corruptie en anti-omkoping",
  Litigations:"Rechtszaken",
  NegativeNews:"Negatief nieuws",
  ESGScore:"ESG-score",
  YearsinBusiness:"Jaren in het bedrijfsleven",
  Competitiveness:"Concurrentievermogen",
  WorkingCapital:"Marktrisico",
  FinancialStructure:"Leveranciersketen Index",
  Industrystatus:"Industriestatus",
  IndustryOutlook:"Industrievooruitzichten",
  NoofCompanies:"Aantal bedrijven",
  IndustryRanking:"Industrie rangschikking",
  IndustryConcentration:"Industrie BBP %",
  IndustryCompetitiveness:"Industry Competitiveness", //未对应
  IndustryDevelopment:"Industry Development",//未对应
  CompanyName:"Bedrijfsnaam",
  Legal:"Juridisch",
  Organizational:"Organisatorisch",
  Operational:"Operationeel",
  Financial:"Financieel",
  Credit:"Kredietrisico",
  Compliance:"Compliance",
  Sustainability:"Sustainability",
  Industry:"Branche",
  Download:"Downloaden",
  StartDate: "Startdatum", 
  EndDate: "Einddatum",
  Entercompanyname: "Voer de bedrijfsnaam in",
  Tryagain:"Probeer het opnieuw",
  //未对应
  Uploadyourlistofcompanies:"Upload your list of companies, and Risk Scan will provide you with instant data updates for each entity. With comprehensive risk assessments across seven risk categories, Risk Scan transforms your risk management from reactive to a proactive strategic advantage.",
  Choose:"Choose",
  Upload:"Upload",
  Uploading:"Uploading",
  Uploadwithamaximumfilesizeof1M:"（Upload up to 100 pieces of data at a time, with a maximum file size of 1M）",
  Theuploadedonlyxlsx:"The uploaded file can only be in xls/xlsx format",
  RiskScanning:"Risk Scanning",
  Youhaveselectedatotalof:"You have selected a total of",
  Tostartriskscanning:"companies, click “confirm” to start risk scanning",
  Datascanningisinprogress:"Data scanning is in progress ...",
  ClearAll:'Clear All',
  SelectUpdateDate:"Select Last Update",
  UpdateStatus:"Update Status",
  Updated:"Updated",
  Notupdated:"Not updated",
  Updating:"Updating",
  SelectRiskValue:"Select Risk Value",
  ReSelectData:"Re Select Data",
  HistoricalData:"Historical Data",
  DiagnosticReport:"Diagnostic Report",
  Good:"Good",
  General:"General",
  Differ:"Differ",
  NotEvaluated:"Not Evaluated",
  ScanTime:"Scan Time",
  Rescan: "Rescan",
},
//Data Management
DataManagement:{
  DataManagement:"gegevensbeheer",
  AllCompanies:"Alle bedrijven",
  CompaniesViewed:"Bedrijven bekeken",
  CompaniesCollected:"Bedrijven verzameld",
  CompaniesUploaded:"Bedrijven geüpload",
  MyPortfolio:"Mijn portefeuille",
  Date:"Datum",
  CompanyName:"Bedrijfsnaam",
  Country:"Land",
  CompanyType:"Bedrijfstype",
  CompanyStatus:"Bedrijfsstatus",
  DQI:"DQI",
  Download:"Download",
  Addcompanies:"Bedrijven toevoegen",
  Filter: "Filter",
  Selectcountry:"Selecteer land",
  Selectindustry:"Selecteer branche",
  Selectcompanytype:"Selecteer bedrijfstype",
  Selectcompanysize:"Selecteer bedrijfsgrootte",
  Selectcompanystatus:"Selecteer bedrijfsstatus",
  Selectlistedcompanies:"Selecteer beursgenoteerde bedrijven",
  Selectcompanyyearsinbusiness:"Selecteer bedrijfsjaren in bedrijf",
  Industry:"Industrie",
  CompanySize:"Bedrijfsgrootte",
  Listed:"Genoteerde",
  CompanyAge:"Bedrijfsleeftijd",
  SelectYear:"Selecteer jaar",
  SelectQuarter:"Selecteer kwartaal",
  SelectMonth:"Selecteer maand",
  Reset:"Reset",
  Search:"Zoekopdracht",
  MyDatabase:"Mijn database",
  CountriesLocated:"gevestigde landen",
  YearsinBusiness:"Jaren in het bedrijf",
  CompanyDQI:"DQI",
  RiskScan:"Risico Scan",
  CreditAssessment:"Kredietbeoordeling",
  Uptodate:"Up-to-date",
  Average:"Gemiddeld",
  Insufficient:"Onvoldoende",
  Good:"Goed",
  Caution:"Voorzichtig",
  Unknown:"Onbekend",
  CompanyTag:"Bedrijfstag",
  Remove:"Verwijderen",
  Uploaded:"Geüpload",
  Identified:"Geïdentificeerd",
  Notmatched:"Niet overeenkomend",
  Uploadfiles:"Bestanden uploaden",
  Identifythecompanywithmanualcheck:"Identificeer het bedrijf met handmatige controle",
  Identifyacompanymanually:"Een bedrijf handmatig identificeren",
  Pleaseprovideanyrelevantinformation:"Geef relevante informatie die de zoekresultaten kan verbeteren. Onze data-analist koppelt u aan het meest geschikte bedrijf.",
  RegistrationID:"Bedrijfs-ID",
  StateProvince:"Staat/provincie",
  Address:"Adres",
  Otherinformation:"Overige informatie",
  Submit:"Indienen",
  Cancel: "Annuleren",
  Confirm:"Bevestigen",
  PortolioName:"Portefeuillenaam",
  User:"Gebruiker",
  Task:"Taak",
  NoofCompanies:"Aantal bedrijven",
  Entercompanyname:"Voer de bedrijfsnaam in",
  SaveYourPortfolio:"Sla uw portefeuille op",
  PortfolioName:"Portefeuillenaam",
  Notes:"Notities",

  //未对应
  Rescan:"Rescan",
  Match:"Match",
  Delete:"Delete",
  Edit:"Edit",
  AllData:"All Data",
  CountriesLocated:"Countries Located",
  EnterRegistrationID:"Enter Registration ID",
  EnterAddress:"Enter Address",
  EnterInformation:"Enter Information",
  EnterPortfolioName:"Enter Portfolio Name",
  EnterUserName:"Enter User",
  SelectTaskName:"Select Task",
  EnterNotes:"Enter Notes",
  OnlineMatching:"Online Matching",
  StartingMonth:"Starting Month",
  EndMonth:"End Month",
},
  ...nlLocale,
};

export default nl;
